import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';
export const COLUNAS_DEFAULT_MODULE_DEPOSITO = [
  {
    module: 'CADASTRO_DEPOSITO',
    colunas: [
      { field: 'codigo', active: true, removable: true },
      { field: 'nome_razao_social', active: true, removable: false },
      {
        field: 'deposito.parceiro.nome_razao_social',
        active: true,
        removable: true
      },
      { field: 'deposito.parceiro.cpf_cnpj', active: true, removable: true }
    ]
  },
  {
    module: 'RSE_DEPOSITO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: true
      },
      {
        field: 'pre_deposito.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'data',
        active: true,
        removable: true
      },
      {
        field: 'observacao',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'TRANSF_DEPOSITO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'data_hora',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'REE_DEPOSITO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: true
      },
      {
        field: 'data',
        active: true,
        removable: true
      },
      {
        field: 'data_compra',
        active: true,
        removable: true
      },
      {
        field: 'data_recebimento',
        active: true,
        removable: true
      },
      {
        field: 'pre_deposito.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'fornecedor.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  }
] as IColunasSettingsUser[];
